import CommentRow from "../CommentRow/CommentRow";

export interface Comment {
  id: string;
  comment: string;
  createdBy: string;
  createdDateTime: string;
}

interface CommentListProps {
  comments?: Comment[];
  onDelete?: (comment: Comment) => void;
}

const CommentList = ({ comments, onDelete }: CommentListProps) => (
  <div>
    {comments?.map(comment => (
      <CommentRow key={comment.id} comment={comment} onDeleteClicked={onDelete} />
    ))}
  </div>
);

export default CommentList;
